module.exports = __webpack_public_path__ + "static/media/r-md9.367a52a4.png";